<template>
    <div>
        <div class="nav primary-bg pl20 pr20 pt10 pb10">
            <div class="box-horizontal">
                <div class="" @click="met.back()">
                    <img src="@/assets/back.png" alt="" style="height:30px">
                </div>
                <div class="flex-1 f13 text-center white">
                    Rincian Tagihan
                </div>
                <div class=""></div>
            </div>
        </div>
            <div class="wrapper">
            <div class="title" @click="get.cek()">
                <p>Berikut rincian pembayaran anda</p>
            </div>
            <div class="body">
                    <div class="tulang" v-show="get.data.loading">
                        <Loading style="height: 50px;" class="mb20">
                        </Loading>
                        <Loading style="height: 120px;" class="mb20">
                        </Loading>
                        <Loading style="height: 50px;" class="mb20">
                        </Loading>
                        <Loading style="height: 50px;" class="mb20">
                        </Loading>
                        <Loading style="height: 50px;" class="mb20">
                        </Loading>
                    </div>
                    <div class="bukan-tulang" v-show="!get.data.loading">
                        <div class="body-box mb20">
                            <div class="box-horizontal">
                                <span class="flex-1 gray f15">Bulan</span>
                                <span class="f15 primary-color text-right">
                                    <span class="block">{{get.data.bulanText}}</span>
                                    <span class="block">{{get.data.bulan1Text}}</span>
                                    <span class="block">{{get.data.bulan2Text}}</span>
                                    <span class="block">{{get.data.bulan3Text}}</span>
                                    
                                </span>
                            </div>
                        </div>
                        <div class="body-box mb20">
                            <div class="box-horizontal">
                                <span class="flex-1 gray">Rincian</span>
                            </div>
                            <div class="box-horizontal">
                                <span class="flex-1 gray">Paket</span>
                                <span class="f12"> {{get.data.paket}}</span>
                            </div>
                            <div class="box-horizontal">
                                <span class="flex-1 gray">Biaya Paket</span>
                                <span class="f12">{{myGlobal.ribu(get.data.pakettarif)}}</span>
                            </div>
                            <div class="box-horizontal" v-show="get.data.ppnpersen != '0'"> 
                                <span class="flex-1 gray">PPN {{get.data.ppnpersen}}%</span>
                                <span class="f12">{{myGlobal.ribu(get.data.ppn)}}</span> 
                            </div>
                            <div class="box-horizontal">
                                <span class="flex-1 gray">Diskon</span>
                                <span class="f12 green">{{myGlobal.ribu(get.data.diskon)}}</span>
                            </div>
                            <div class="box-horizontal"  v-if="get.data.biaya_1 != null || get.data.biaya_2 != null">
                                <span class="flex-1 gray">Biaya Tambahan</span>
                            </div>
                            <div class="box-horizontal" v-if="get.data.biaya_1 != null ">
                                <span class="flex-1 gray">- {{get.data.biaya_rincian_1}}</span> 
                                <span class="f12">{{myGlobal.ribu(get.data.biaya_1)}}</span>
                            </div>
                            <div class="box-horizontal"  v-if="get.data.biaya_2 != null ">
                                <span class="flex-1 gray">- {{get.data.biaya_rincian_2}}</span>
                                <span class="f12">{{myGlobal.ribu(get.data.biaya_2)}}</span>
                            </div>
                            <div v-if="get.data.x.stat != 'sudah'">
                                <span class="box-horizontal" v-if="get.data.params.jenis == 'qris'">
                                    <span class="flex-1 gray">Biaya Operasional Aplikasi</span>
                                    <span class="f12">{{myGlobal.ribu( get.data.biaya_admin)}}</span>
                                </span>
                                <span class="box-horizontal" v-else-if="get.data.params.jenis == 'ewallet'">
                                    <span class="flex-1 gray">Biaya Operasional</span>
                                    <span class="f12">{{myGlobal.ribu( get.data.biaya_admin)}}</span>
                                </span>
                                <span class="box-horizontal" v-else-if="get.data.params.jenis == 'va'">
                                    <span class="flex-1 gray">Biaya Admin</span>
                                    <span class="f12">{{myGlobal.ribu( get.data.biaya_admin)}}</span>
                                </span>
                                <span class="box-horizontal" v-else-if="get.data.params.jenis == 'retail'">
                                    <span class="flex-1 gray">Biaya Admin</span>
                                    <span class="f12 primary-color">Langsung Di Kasir</span>
                                </span>
                                <span class="box-horizontal" v-else-if="get.data.params.jenis == 'tripay-retail'">
                                    <span class="flex-1 gray">Biaya Admin</span>
                                    <span class="f12 primary-color">{{myGlobal.ribu( get.data.biaya_admin)}}</span>
                                </span>
                                <div class="box-horizontal" v-show="get.data.diskonOnline != '0'">
                                    <span class="flex-1 gray">Diskon Bayar Online</span>
                                    <span class="green f15">{{myGlobal.ribu(get.data.diskonOnline)}}</span>
                                </div>
                            </div>
                        </div>
                        <div class="body-box mb20" v-if="get.data.x.stat != 'sudah'">
                            <div class="box-horizontal">
                                <span class="flex-1">Via</span>
                                <span class="f12 primary-color" style="text-transform:uppercase">
                                    {{get.data.params.via}}
                                    <span v-if="get.data.params.jenis == 'va'"> VA</span> 
                                </span>
                            </div>
                            <div class="block" v-if="get.data.params.via == 'ovo'">
                                <div class="box-horizontal">
                                    <span class="flex-1">Nomer OVO</span>
                                    <span class="f12 primary-color">{{get.data.ovoTelp}}</span>
                                    <button class="btn btn-sm btn-info ml10" @click="get.data.teleponGantiBox = true">Ganti</button>
                                </div>
                                <div class="mb20 text-center info p10 f12 gray box-horizontal" v-show="get.data.teleponGantiBox">
                                    <input type="number" v-model="get.data.teleponGanti" class="hitam pt10 pb10 w100 f13 flex-1" style="border:0; border-bottom:0px solid #333; background-color:rgba(0,0,0,0)" placeholder="Telepon Ovo...">
                                    <button class="btn btn-sm btn-success ml10" @click="met.simpanOvo()">Simpan</button>
                                </div>
                                <div class="mb20 text-center info-gray p10 f12 gray">
                                    Pastikan Nomer diatas sama dengan dompet OVO Anda. Agar Anda bisa menerima tagihan pembayaran dari Merchant My Wifi / Beatcom RTRW.
                                </div>
                            </div>
                            <div class="box-horizontal">
                                <span class="flex-1 f15">Total Pembayaran</span>
                                <span class="f15 primary-color" v-if="get.data.diskonOnline == '0'"><strong>{{myGlobal.ribu(get.data.tarif + get.data.biaya_admin)}} </strong></span>
                                <span class="f15 primary-color" v-else><s class="f12 gray">{{myGlobal.ribu(get.data.tarif + get.data.biaya_admin)}}</s> <strong>{{myGlobal.ribu((get.data.tarif + get.data.biaya_admin) - get.data.totalDiskonOnline)}} </strong></span>
                            </div>
                        </div> <!-- <s>JavaScript</s> -->
                        <button class="btn btn-success w100 mb20" @click="get.confirmPembayaran()" v-if="get.data.x.stat != 'sudah'">Bayar Sekarang</button>
                        <div class="info text-center biru p10" v-if="get.data.x.stat != 'sudah'">
                            Setelah menekan tombol bayar sekarang. Kode Pembayaran anda akan di buatkan.
                        </div>
                        <div class="info text-center white p10" v-if="get.data.x.stat == 'sudah'">
                            Anda telah melakukan pembayaran bulan ini
                        </div>
                    </div>
                
            </div>
        </div>

        <div class="toast" v-show="get.data.toastShow">
            <span class="text-center block w100">{{get.data.toastText}}</span>
        </div>

    </div>
</template>

<script>
import { reactive } from '@vue/composition-api'
import myGlobal from '@/MyGlobal'
import store from '@/store/index'
import inter from '@/Interface'
import router from '@/router'
import Loading from '@/global/Loading' 

export default {
    components: { 
        'Loading': Loading
    },
    setup() {
        const get = {
            data: reactive({
                this: '',
                hasil: "",

                bulan: null,
                tahun: null,
                bulan1: null,
                tahun1: null,
                bulan2: null,
                tahun2: null,
                bulan3: null,
                tahun3: null,

                bulanText: '',
                bulan1Text: '',
                bulan2Text: '',
                bulan3Text: '',
                tahun: '',
                tarif: 0,
                x: '',
                loading: true,
                params: '',
                paket: '',
                pakettarif: '',
                ppnpersen: '',
                ppn: '',
                diskon: null,
                biaya_1: null, 
                biaya_rincian_1: null,
                biaya_2: null,
                biaya_rincian_2: null,
                biaya_admin: null,
                //totalAll: 0,
                diskonOnline: null,
                totalDiskonOnline: null,

                toastShow: false,
                toastText: 'text',
                ovoTelp: '',
                teleponGantiBox: false,
                teleponGanti: '',
                confirmClick: 0 // apakah konfirmasi bayar pernah terklik 0 = belum pernah, 1 = pernah
            }),
            list() {
                /*
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem('Token')
                };
            
                var apiUrl = inter.KategoriList();

                myGlobal.call(datax,apiUrl).then(x => {
                    //console.log(JSON.stringify(x));
                    //data.loading = false;
                    if (x.status == true) {
                        mainData.data = x.data;
                        //theGet.data.Total = x.pesan;
                    } else {
                        
                    }
                })
                */
            },
            cek() {
                myGlobal.android("toast", "token e " + sessionStorage.getItem("tokenu"));
            },
            /*
            tagihan() {
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem("tokenu")
                };
            
                var apiUrl = inter.tagihan(); 

                myGlobal.call(datax,apiUrl).then(x => {
                    

                    //console.log(JSON.stringify(x));

                    if (x.status == true) {

                        this.data.bulan = x.data.bulan;
                        this.data.tahun = x.data.tahun;
                        this.data.x = x.data;

                        if (x.data.stat == 'sudah') {
                            if (x.data.stat_bayar == "pending") {
                                router.push({ name: 'success', params: { invoice: x.data.invoice, via: 'ovo', external_id:x.data.external_id, qr:x.data.qr  } });
                            }
                            
                        }

                        //theGet.data.Total = x.pesan;

                    } else {
                        
                    }
                })
            },
            
            */
           
            batalkanPembyaran: async() => {
                //console.log("Batalin dulu");

                var datax = {
                    token: 'TangTung '+sessionStorage.getItem("tokenu"),
                    qrid: get.data.params.qrid
                }
                
                var apiUrl = inter.BatalBayar();

                return myGlobal.call(datax,apiUrl).then(x => {
                    console.log(JSON.stringify(x));
                })
            },
            
            async confirmPembayaran() {
                if (get.data.params.qrid != null) {
                    await get.batalkanPembyaran();
                }

                if (get.data.confirmClick == 1) {
                    return false;
                }
                
                get.data.confirmClick = 1; // sudah di klik ya

                if (get.data.params.via == "ALFAMART") {
                    if (get.data.tarif < 10000) {
                        myGlobal.android("toast", "Minimal pembayaran 10rb");

                        get.data.toastShow = true;
                        get.data.toastText = "Minimal pembayaran 10rb";
                        setTimeout(function() {
                            get.data.toastShow = false;
                        }, 3000);
                        
                        return false;
                    }
                } else if (get.data.params.via == "INDOMARET") {
                    if (get.data.tarif < 10000) {
                        myGlobal.android("toast", "Minimal pembayaran 10rb");

                        get.data.toastShow = true;
                        get.data.toastText = "Minimal pembayaran 10rb";
                        setTimeout(function() {
                            get.data.toastShow = false;
                        }, 3000);

                        return false;
                    }
                } else if (get.data.params.via == "ALFAMIDI") {
                    if (get.data.tarif < 10000) {
                        myGlobal.android("toast", "Minimal pembayaran 10rb");

                        get.data.toastShow = true;
                        get.data.toastText = "Minimal pembayaran 10rb";
                        setTimeout(function() {
                            get.data.toastShow = false;
                        }, 3000);

                        return false;
                    }
                }

                myGlobal.android("loading", "Pembayaran anda sedang dibuat...");

                var datax = {
                    token: 'TangTung '+sessionStorage.getItem("tokenu"),
                    via: get.data.params.via,
                    bulan: this.data.bulan,
                    tahun: this.data.tahun,
                    bulan1: this.data.bulan1,
                    tahun1: this.data.tahun1,
                    bulan2: this.data.bulan2,
                    tahun2: this.data.tahun2,
                    bulan3: this.data.bulan3,
                    tahun3: this.data.tahun3,
                    success_link: "#/success-ewallet" // e wallet only
                };

                if (get.data.params.via == "ovo") {
                    datax["telp"] = get.data.ovoTelp;
                }

                //console.log(JSON.stringify(datax));

                //return false;

                if (get.data.params.jenis =='qris') {
                    var apiUrl = inter.ReqBayar();
                } else if (get.data.params.jenis =='ewallet') {
                    var apiUrl = inter.ReqBayarEwallet();
                } else if (get.data.params.jenis =='va') {
                    var apiUrl = inter.ReqBayarVA();
                } else if (get.data.params.jenis =='retail') {
                    var apiUrl = inter.ReqBayarRetail();
                } else if (get.data.params.jenis =='tripay-retail') {
                    var apiUrl = inter.ReqBayarRetailIndomaret();
                }
                
                // console.log(JSON.stringify(datax));


                myGlobal.call(datax,apiUrl).then(x => {
                    //data.loading = false;

                    //console.log(JSON.stringify(x));

                    //return false;

                    myGlobal.android("loadingHide", null);

                    if (x.status == true) {
                        this.data.hasil = x.pesan;

                        //theGet.data.Total = x.pesan;
                        if (get.data.params.jenis =='qris') {
                            router.push({ 
                                name: 'success', 
                                params: { 
                                    invoice: x.data.invoice, 
                                    via: get.data.params.via, 
                                    external_id: x.data.external_id, 
                                    qr:x.data.qr
                                } 
                            });
                        } else if (get.data.params.jenis =='ewallet') {
                            // JIKA OVO LANGSUNG KE HALAMAN SUKSES KARENA APA, PAKE NANYA OVO ITU LANJUTKAN BAYARNYA GA VIA LINK LANGSUNG DI APP
                            if (get.data.params.via == "ovo") {

                                router.push({ 
                                    name: 'success-ewallet', 
                                    params: { 
                                        invoice: x.data.invoice, 
                                        via: get.data.params.via, 
                                        qr: get.data.ovoTelp
                                    } 
                                });

                                return false;
                            }

                            router.push({ 
                                name: 'proses-bayar', 
                                params: { 
                                    invoice: x.data.invoice, 
                                    via: get.data.params.via, 
                                    qr:x.data.data
                                } 
                            });
                        } else if (get.data.params.jenis =='va') {
                            router.push({ 
                                name: 'success-va', 
                                params: { 
                                    invoice: x.data.invoice, 
                                    via: get.data.params.via, 
                                    external_id: x.data.external_id, 
                                    data: x.data.respon
                                } 
                            });
                        } else if (get.data.params.jenis =='retail') {
                            router.push({ 
                                name: 'success-retail', 
                                params: { 
                                    invoice: x.data.invoice, 
                                    via: get.data.params.via, 
                                    external_id: x.data.external_id, 
                                    data: x.data.respon
                                } 
                            });
                        } else if (get.data.params.jenis =='tripay-retail') {
                            router.push({ 
                                name: 'success-tripay-retail', 
                                params: { 
                                    invoice: x.data.invoice, 
                                    via: get.data.params.via, 
                                    external_id: x.data.external_id, 
                                    data: x.data.respon
                                } 
                            });
                        }

                        //link.success();
                    } else {
                        
                    }

                })
            },
            tagihancek() {
                var datax = {
                    token: 'TangTung '+sessionStorage.getItem("tokenu")
                };
            
                var apiUrl = inter.Tagihan(); 

                myGlobal.call(datax,apiUrl).then(x => {
                    //console.log(JSON.stringify(x));

                    get.data.loading = false;

                    if (x.status == true) {
                        var d = x.data;
                        //this.data.tanggallimit = d.last + " " +d.bulanNow + " " +d.tahunAngka;

                        var ppne = d.ppn;
                        var ppn = (parseInt(ppne) / 100 ) * parseInt(d.tarif);

                        var tariff = ( myGlobal.sParseInt(d.tarif) + myGlobal.sParseInt(d.tambahan1) + myGlobal.sParseInt(d.tambahan2) + ppn ) - myGlobal.sParseInt(d.diskon);

                        var tarifx = tariff;

                        this.data.bulanText = d.bulanNow + " " + d.tahunAngka;

                        this.data.bulan = d.bulanAngka;
                        this.data.tahun = d.tahunAngka;
                        
                        // DISKON BAYAR ONLINE PERBULAN
                        get.data.totalDiskonOnline = get.data.diskonOnline;

                        if (d.bulanmin3data.isBayar != "sudah" && d.bulanmin3data.isIsolir != "ya") {
                            if (d.bulanmin3data.isBayar != "register") {
                                this.data.bulan3Text = d.bulanmin3data.bulanText + " " + d.bulanmin3data.tahunAngka;
                                tarifx = tarifx + tariff;
                                
                                this.data.bulan3 = d.bulanmin3data.bulanAngka;
                                this.data.tahun3 = d.bulanmin3data.tahunAngka;

                                // DISKON BAYAR ONLINE PERBULAN
                                get.data.totalDiskonOnline = myGlobal.sParseInt(get.data.totalDiskonOnline) + myGlobal.sParseInt(get.data.diskonOnline);
                            }
                        }
                        
                        if (d.bulanmin2data.isBayar != "sudah" && d.bulanmin2data.isIsolir != "ya") {
                            if (d.bulanmin2data.isBayar != "register") {
                                this.data.bulan2Text = d.bulanmin2data.bulanText + " " + d.bulanmin2data.tahunAngka;
                                tarifx = tarifx + tariff;
                                
                                this.data.bulan2 = d.bulanmin2data.bulanAngka;
                                this.data.tahun2 = d.bulanmin2data.tahunAngka;

                                // DISKON BAYAR ONLINE PERBULAN
                                get.data.totalDiskonOnline = myGlobal.sParseInt(get.data.totalDiskonOnline) + myGlobal.sParseInt(get.data.diskonOnline);
                            }
                        }
                        if (d.bulanmin1data.isBayar != "sudah" && d.bulanmin1data.isIsolir != "ya") {
                            if (d.bulanmin1data.isBayar != "register") {
                                this.data.bulan1Text = d.bulanmin1data.bulanText + " " + d.bulanmin1data.tahunAngka;
                                tarifx = tarifx + tariff;
                                
                                this.data.bulan1 = d.bulanmin1data.bulanAngka;
                                this.data.tahun1 = d.bulanmin1data.tahunAngka;
                                
                                // DISKON BAYAR ONLINE PERBULAN
                                get.data.totalDiskonOnline = myGlobal.sParseInt(get.data.totalDiskonOnline) + myGlobal.sParseInt(get.data.diskonOnline);
                            }
                        }                        

                        this.data.tarif = tarifx;

                        if (d.isBayar == "sudah" &&
                         d.bulanmin3data.isBayar == "sudah" && 
                         d.bulanmin2data.isBayar == "sudah" && 
                         d.bulanmin1data.isBayar == "sudah" ) {
                            this.data.stat = "sudah";
                        }

                        this.data.ppnpersen = ppne;
                        this.data.ppn = ppn;
                        this.data.paket = d.paket;
                        this.data.pakettarif = d.tarif;
                        this.data.diskon = d.diskon;
                        this.data.biaya_1 = d.tambahan1;
                        this.data.biaya_2 = d.tambahan2;
                        this.data.biaya_rincian_1 = d.rincian1; 
                        this.data.biaya_rincian_2 = d.rincian2; 
                        if (get.data.params.jenis == "qris") {
                            //this.data.biaya_admin = (parseInt(this.data.tarif) / 100) * 2;


                            let tarifX = tarifx; 
                            console.log(tarifX);
                            let tarifX750 = parseInt(tarifX) + 0;
                            console.log(tarifX750);
                            let tarifX2persen = (parseInt(tarifX750) / 100) * 2;
                            console.log(tarifX2persen);
                            let tarifX1persen = ((parseInt(tarifX750) + parseInt(tarifX2persen)) / 100) * 1;
                            console.log(tarifX1persen);
                            let tarifX4000 = parseInt(tarifX2persen) + parseInt(tarifX1persen) + 4000 ;
                            console.log(tarifX4000);

                            console.log("halo bro")

                            this.data.biaya_admin = tarifX4000;
                            
                        } else if (get.data.params.jenis == "ewallet") {
                            this.data.biaya_admin = (parseInt(this.data.tarif) / 100) * 2;
                        } else if (get.data.params.jenis == "va") {
                            this.data.biaya_admin = 6000;
                        } else if (get.data.params.jenis == "retail") {
                            this.data.biaya_admin = 6000;
                        } else if (get.data.params.jenis == "tripay-retail") {
                            this.data.biaya_admin = 8000;
                        }

                        //this.data.totalAll = this.data.biaya_admin + this.data.tarif;


                        //IKI OJOK LALI COK
                        // INI GA DI PAKAI SIH, SOALNYA KALO PENDING TOMBOLNYA GA BISA DI EDIT, HARUS DI LANJUT VIA HISTORY PEMBAYRAN
                        if (this.data.stat == 'sudah') {
                            if (d.stat_bayar == "pending") {
                                router.push({ name: 'success', params: { invoice: d.invoice, via: get.data.params.via, external_id:d.external_id, qr:d.qr  } });
                            }
                        }

                        /*
                        */
                    } else { 
                        
                    }
                })
            }
        }

        const met = {
            back() {
                window.history.back();
            }, 
            simpanOvo() {
                if (get.data.teleponGanti == "") {
                    
                    get.data.toastShow = true;
                    get.data.toastText = "Nomor tidak boleh kosong";
                    setTimeout(function() {
                        get.data.toastShow = false;
                    }, 3000);
                    
                    return false;
                }
                if (get.data.teleponGanti.length < 9) {
                    get.data.toastShow = true;
                    get.data.toastText = "Masak Nomer telepon kurang dari 9?";
                    setTimeout(function() {
                        get.data.toastShow = false;
                    }, 3000);

                    return false;
                }

                get.data.ovoTelp = get.data.teleponGanti;
                get.data.teleponGantiBox = false;

                get.data.teleponGanti = "";
            }
        }
        
        const redirectx = {
            checkApp() {
                myGlobal.checkApp();
            },
            now() {
                location.href="#/";
            }
        }

        return {
            store,
            get,
            myGlobal,
            inter,
            get,
            redirectx,
            met
        }

    },
    mounted () {
        this.redirectx.checkApp();
        //myGlobal.android("setTitle", "Rincian");

        this.get.data.this = this;

        // this.get.tagihan();
        this.get.data.params = this.$route.params;
        
        this.get.tagihancek();
        
        var d = JSON.parse(sessionStorage.getItem('data_profil'));
        this.get.data.ovoTelp = d.uwa;
        this.get.data.diskonOnline = d.diskon_online;
        console.log("Diskon online " + this.get.data.diskonOnline);
        
        //myGlobal.android("toast", this.get.data.params.via);

        this.get.data.confirmClick = 0;
        
        
    },
    render: h => h(App)
}
</script>


// WEBPACK FOOTER //
// src/components/User/Rincian-Bayar/main.vue